export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/mongo.98df92b.svg";